import { render, staticRenderFns } from "./SorteoEstadisticaTotal.vue?vue&type=template&id=b469e0c6&"
import script from "./SorteoEstadisticaTotal.vue?vue&type=script&lang=ts&"
export * from "./SorteoEstadisticaTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports